<template>
  <div class="lab-assignments-widget">
    <div>
      <allLabAssignmentsOverview/>
    </div>
  </div>
</template>
<script>
import allLabAssignmentsOverview from '@/components/table-overviews/allLabAssignmentsOverview'

export default {
  name: 'labAssignmentsInfoWidget',
  components: {
    allLabAssignmentsOverview
  }
}
</script>
<style lang="less" scoped>
.lab-assignments-widget /deep/ .dx-toolbar {
  background-color: @white;
}
.lab-assignments-widget /deep/ .dx-datagrid-header-panel {
  background-color: @white;
}
.lab-assignments-widget {
  height: 100%;
  width: 100%;
}
</style>
